<template>
    <tr>
        <td class="small">
            <b-form-checkbox
                    v-on:change="toggle"
                    v-model="selected"
            ></b-form-checkbox>
        </td>
        <td class="username">
          <a class="action detail-link" v-on:click="showDetail">{{ data.email }}</a>
        </td>
        <td v-bind:data-th="$t('user.firstname')">
          {{ data.firstname }}
        </td>
        <td v-bind:data-th="$t('user.lastname')">
          {{ data.lastname }}
        </td>
        <td>
            {{ data.sites }}
        </td>
        <td>
            <span v-if="data.valid_payment === true">
                <font-awesome-icon class="success-color" :icon="['fal','check-circle']"></font-awesome-icon>
            </span>
            <span v-else>
                <font-awesome-icon class="danger-color" :icon="['fal','exclamation-circle']"></font-awesome-icon>
            </span>
        </td>
        <td>
            <span v-if="data.valid_profile === true">
                <font-awesome-icon class="success-color" :icon="['fal','check-circle']"></font-awesome-icon>
            </span>
            <span v-else>
                <font-awesome-icon class="danger-color" :icon="['fal','exclamation-circle']"></font-awesome-icon>
            </span>
        </td>
        <td>
            <span v-if="data.service_enabled === true">
                <font-awesome-icon class="success-color" :icon="['fal','check-circle']"></font-awesome-icon>
            </span>
            <span v-else>
                <font-awesome-icon class="danger-color" :icon="['fal','exclamation-circle']"></font-awesome-icon>
            </span>
        </td>
        <td>
            <span v-if="data.pre_delete === true">
                <font-awesome-icon class="danger-color" :icon="['fal','user-slash']"></font-awesome-icon>
            </span>
        </td>
        <td class="actions">
          <button v-if="userId !== data.id" v-on:click="localImpersonate" @mousedown.prevent class="btn btn--primary">
            {{ $t("user.impersonate") }}
          </button>
          <button v-if="userId !== data.id && data.pre_delete === false" v-on:click="localRemove" @mousedown.prevent class="btn btn--failed--link">
            <span class="icon">
                <img src="/images/icon/siteinformation/icon_trash.svg"/>
            </span>
          </button>
        </td>
    </tr>
</template>

<script>

import { mapState, mapActions, mapMutations } from 'vuex'

import mixins from '../../mixins'

export default {
  name: 'UsersItem',

  mixins: [mixins],

  props: [
    'id',
    'data',
    'details',
    'dirty',
    'inProgress'
  ],

  computed: {
    ...mapState(
      'user', [
        'userSelected',
        'showDetailPage',
        'userDetailId',
        'userId'
      ]
    ),

    selected: {
      get () {
        return this.userSelected.includes(this.id)
      },
      set (value) {
        // just do nothing
      }
    }

  },

  methods: {
    ...mapMutations('common', [
      'endLoading',
      'resetLoading'
    ]),

    ...mapMutations('user', [
      'addSelectedUser',
      'removeSelectedUsers',
      'setUserDetailId',
      'closeDetailPage'
    ]),

    ...mapActions('user', [
      'setUserDetailContent',
      'impersonate'
    ]),

    localRemove () {
      this.$router.push({
        name: 'userDestroy',
        params: {
          id: this.id
        }
      }, this.endLoading())
    },

    showDetail () {
      if (this.id === this.userDetailId && this.showDetailPage) {
        this.closeDetailPage()
      } else {
        this.setUserDetailContent(this.id)
      }
    },

    toggle (e) {
      if (e) {
        this.addSelectedUser(this.id)
      } else {
        this.removeSelectedUsers(this.id)
      }
    },

    localImpersonate () {
      this.impersonate(this.id).then(() => {
        window.location.href = '/'
      })
    }
  }
}
</script>
